import React, { FC, useState } from "react";
import { Input } from '@brg/input';
import { useTranslation } from 'react-i18next';
import { Button, FlexBox, Fonts, useToasts } from '@brg/ui';
import { API, Endpoints, CoreAPI } from '@brg/api';
import styled, { useTheme } from 'styled-components';

export const FeedbackWrapper = styled(FlexBox)`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  justify-content: space-between;

  textarea {
      height: 105px !important;
  }
`;

export const FeeadbackTitle = styled(FlexBox)`
    ${Fonts.Inter.sectionTitle};
    color: ${(p) => p.theme.feedbackForm.text};
`;


export interface FeedbackFormProps {
  entityId: string,
  entityType: string,
  handleClose: () => void
}

/**
 * **FeedbackForm** - форма отправки отзыва
 *
 * @param props
 */
export const FeedbackForm: FC<FeedbackFormProps> = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { handleClose, entityId, entityType } = props;
  const [comment, setComment] = useState<string>("");
  const [disabled, setDisabled] = useState<boolean>(false);
  const toasts = useToasts();

  const onClickHandler = async (ev: React.MouseEvent) => {
    try {
      setDisabled(true);

      const req = CoreAPI.createPOST(
        Endpoints.geograffee + '/api/Feedback/FeedbackAuthor',
        {
          EntityId: entityId,
          EntityType: entityType,
          Message: comment,
        },
        {},
      );
      await API.fetch(Endpoints.geograffee + '/api/Feedback/FeedbackAuthor', req);

      toasts.info(t('feedback.feedback_success'));

      if (handleClose)
        handleClose();
    } catch (error) {
      toasts.error(t('feedback.feedback_error'));
      console.error(error);
      setDisabled(false);
    }
  };

  return (
    <FeedbackWrapper>
      <FlexBox width={'100%'} direction={'column'} directionMobile={'column'}>
        <FlexBox direction={'column'} directionMobile={'column'} ox={24} offsetBottom={24}>
          <Input.Textarea
            style={{
              backgroundColor: theme.feedbackForm.inputs.backgroundColor,
              borderColor: theme.feedbackForm.inputs.borderColor,
              color: theme.feedbackForm.inputs.color
            }}
            rows={5}
            onChange={(value: any) => setComment(value.target.value)}
            placeholder={t("feedback.comment")}
            value={comment}
          />
        </FlexBox>
        <FlexBox justify={'end'} ox={24} offsetBottom={24}>
          <FlexBox>
            <Button.YellowMedium 
              style={{
                color: theme.feedbackForm.btns.submit.color,
                backgroundColor: theme.feedbackForm.btns.submit.bg,
                border: theme.feedbackForm.btns.submit.border,
              }}
              onClick={onClickHandler}
              disabled={disabled || comment.length <= 3}>
              {t('feedback.button_send')}
            </Button.YellowMedium>
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </FeedbackWrapper>
  );
};import React, { FC, useState } from "react";
import { Input } from '@brg/input';
import { useTranslation } from 'react-i18next';
import { Button, FlexBox, Fonts, useToasts } from '@brg/ui';
import { API, Endpoints, CoreAPI } from '@brg/api';
import styled, { useTheme } from 'styled-components';

export const FeedbackWrapper = styled(FlexBox)`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  justify-content: space-between;

  textarea {
      height: 105px !important;
  }
`;

export const FeeadbackTitle = styled(FlexBox)`
    ${Fonts.Inter.sectionTitle};
    color: ${(p) => p.theme.feedbackForm.text};
`;


export interface FeedbackFormProps {
  entityId: string,
  entityType: string,
  handleClose: () => void
}

/**
 * **FeedbackForm** - форма отправки отзыва
 *
 * @param props
 */
export const FeedbackForm: FC<FeedbackFormProps> = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { handleClose, entityId, entityType } = props;
  const [comment, setComment] = useState<string>("");
  const [disabled, setDisabled] = useState<boolean>(false);
  const toasts = useToasts();

  const onClickHandler = async (ev: React.MouseEvent) => {
    try {
      setDisabled(true);

      const req = CoreAPI.createPOST(
        Endpoints.geograffee + '/api/Feedback/FeedbackAuthor',
        {
          EntityId: entityId,
          EntityType: entityType,
          Message: comment,
        },
        {},
      );
      await API.fetch(Endpoints.geograffee + '/api/Feedback/FeedbackAuthor', req);

      toasts.info(t('feedback.feedback_success'));

      if (handleClose)
        handleClose();
    } catch (error) {
      toasts.error(t('feedback.feedback_error'));
      console.error(error);
      setDisabled(false);
    }
  };

  return (
    <FeedbackWrapper>
      <FlexBox width={'100%'} direction={'column'} directionMobile={'column'}>
        <FlexBox direction={'column'} directionMobile={'column'} ox={24} offsetBottom={24}>
          <Input.Textarea
            style={{
              backgroundColor: theme.feedbackForm.inputs.backgroundColor,
              borderColor: theme.feedbackForm.inputs.borderColor,
              color: theme.feedbackForm.inputs.color
            }}
            rows={5}
            onChange={(value: any) => setComment(value.target.value)}
            placeholder={t("feedback.comment")}
            value={comment}
          />
        </FlexBox>
        <FlexBox justify={'end'} ox={24} offsetBottom={24}>
          <FlexBox>
            <Button.YellowMedium 
              style={{
                color: theme.feedbackForm.btns.submit.color,
                backgroundColor: theme.feedbackForm.btns.submit.bg,
                border: theme.feedbackForm.btns.submit.border,
              }}
              onClick={onClickHandler}
              disabled={disabled || comment.length <= 3}>
              {t('feedback.button_send')}
            </Button.YellowMedium>
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </FeedbackWrapper>
  );
};